import XLSX from 'xlsx'
import millify from 'millify'
import React, { Component, useState } from 'react'
import * as FileSaver from 'file-saver'
import {
  Anchor,
  Box,
  Button,
  DataTable,
  Grid,
  Heading,
  Main,
  Stack,
  Tab,
  Tabs,
  Text
} from 'grommet'
import { buildNameToColorMapping, departments, destinations, opsAPI } from '../api/retail'
import Excel from 'exceljs'
import { saveAs } from 'file-saver'
import { brandColors, graphColors, meshTheme, nivoTheme } from '../libs/theme'
import { LoadingHeader, PageHeader } from './Common'
import { Co2, FoodRescue, Meals, Money } from '../MeshIcon'

import withOpsApi from './withOpsApi'
import {
  abbreviateNumber,
  calculateImpactMetrics,
  getTotalByKeyFromResults,
  monthNames,
  numberWithCommas
} from '../libs/common'
import { CircleInformation, CloudDownload, Down, Download } from 'grommet-icons'
import { SelectMonthInYear } from './Select'
/* convert from array of arrays to workbook */
// const worksheet = XLSX.utils.aoa_to_sheet(DonationData)
import { ResponsivePie } from '@nivo/pie'
import { ResponsiveLine } from '@nivo/line'
import { ApiLineGraph } from './Corporate'
import { PropagateLoader } from 'react-spinners'
import moment from 'moment-timezone'

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
const colorMapping = buildNameToColorMapping()
export const PieToolTip = ({ id, value, label, color }) => {
  return (
    <Box
      background={color}
      pad={'small'}
      round={'xsmall'}
      gap={'xsmall'}
      width={'small'}
      border={'xxsmall'}
      elevation={'large'}
    >
      <Box fill={'horizontal'} gap={'small'} direction="row" justify="between">
        <Text weight="bold">{label}</Text>
        <Text weight="bold">{millify(value) + ' kg'}</Text>
      </Box>
    </Box>
  )
}
const DonationsPie = ({ data }) => {
  const getColor = (data) => {
    return colorMapping.destinations[data.label] || colorMapping.departments[data.label]
  }
  const getPercentForPie = (value = 0) => {
    let total = 0
    Object.values(data).forEach((d) => {
      total += d.value
    })
    return millify(total ? ((value || 0) / total) * 100 : 0, {
      precision: 0,
      units: ['%']
    })
  }
  return (
    <ResponsivePie
      data={data}
      theme={{
        textColor: meshTheme.global.colors['dark-6'],
        fontSize: 13
      }}
      margin={{ top: 20, right: 50, bottom: 20, left: 50 }}
      innerRadius={0.5}
      padAngle={0.9}
      colors={getColor}
      cornerRadius={4}
      activeOuterRadiusOffset={8}
      valueFormat={(value) => millify(value) + ' kg'}
      borderWidth={1}
      borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
      // arcLinkLabelsTextColor={{ from: 'color' }}
      arcLinkLabelsDiagonalLength={10}
      arcLinkLabelsStraightLength={10}
      arcLinkLabelsThickness={2}
      // arcLinkLabelsTextColor={{ from: 'color' }}
      arcLinkLabelsColor={{ from: 'color' }}
      arcLinkLabelsSkipAngle={25}
      arcLabelsSkipAngle={25}
      arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
      // arcLinkLabel={(d) => d.label}
      arcLinkLabel={(d) => d.label + ' - ' + getPercentForPie(d.value)}
      tooltip={({ datum }) => <PieToolTip {...datum} />}
      // tooltip={({ datum: { id, value, color } }) => (
      //   <div style={{ padding: 12, color, background: '#222222' }}>
      //     <span>Look, m custom :)</span>
      //     <br />
      //     <strong>
      //       {id}: {value}
      //     </strong>
      //   </div>
      // )}
    />
  )
}
export const MetricsBox = ({ item, width, loading = false }) => (
  <Box
    background={'white'}
    flex={false}
    align="center"
    justify={'center'}
    width={width}
    responsive={false}
    round={'small'}
    elevation={'small'}
    key={item.id}
    gap={'xsmall'}
    // margin={{ right: 'small', bottom: 'small' }}
    pad={{ vertical: 'small', horizontal: 'xsmall' }}
    style={loading ? { opacity: '33%' } : undefined}
  >
    <Box round={'small'} gap={'xsmall'} align={'center'}>
      {item.Icon && <item.Icon color={'dark-6'} size={'40px'} />}

      <Text size={'125%'} weight={'bold'}>
        {item.unit !== '$' && millify(Math.ceil(item.value)) + ' '}
        <Text weight={'bold'} size={'small'}>
          {item.unit}
        </Text>
        {item.unit === '$' && ' ' + millify(Math.ceil(item.value))}
      </Text>

      <Text size={'small'} color={'dark-6'} weight={'bold'}>
        {item.name}
      </Text>
    </Box>
  </Box>
)

export const MetricsBoxPoster = ({ item, width, loading = false, background }) => (
  <Box
    flex={false}
    align="center"
    justify={'center'}
    width={width}
    responsive={false}
    key={item.id}
    gap={'xxsmall'}
    // margin={{ right: 'small', bottom: 'small' }}
    pad={{ vertical: 'small', horizontal: 'xsmall' }}
    style={loading ? { opacity: '33%' } : undefined}
  >
    {/* <Box gap={'xsmall'} align={'center'}> */}
    <Box gap={'xsmall'} align={'center'}
      round={'small'}
      //background={background}
      background={item.bgcolor}
      width={'170px'}
      height={'355px'}
      flex={false}
      elevation={'none'}
      justify={'center'}
    >
      {item.Icon && (
        <Box
          round={'full'}
          //background={background}
          background={item.color}
          width={'120px'}
          height={'120px'}
          flex={false}
          align={'center'}
          justify={'center'}
          margin='25px 0'
        >
          <item.Icon color={'white'} size={'80px'}/>
        </Box>
      )}
      {!item.Icon && (
        <Box
          round={'full'}
          //background={background}
          background={item.color}
          width={'120px'}
          height={'120px'}
          flex={false}
          align={'center'}
          justify={'center'}
          margin='25px 0'
        >
          <Box color={'white'} width={'120px'} height={'120px'}/>
        </Box>
      )}

      {/* <Text size={'200%'} weight={'bold'}> */}
      <Text 
        style={{ fontFamily: 'Arvo, sans-serif', margin: '15px 0'}} 
        color={'mesh-green-2'} 
        size={'20px'} 
        weight={'bold'}
      >
        {item.id === 'labels' &&
        <Box align={'center'}>
        <Text 
          style={{ fontFamily: 'Arvo, sans-serif'}}
          size={'18px'} 
          color={'mesh-green-2'} 
          weight={'bold'}
          

        >
          Impact in
        </Text>
        <Text 
          style={{ fontFamily: 'Arvo, sans-serif'}}
          size={'18px'} 
          color={'mesh-green-2'} 
          weight={'bold'}
        >
        {item.start_dateLM}
        </Text>
        </Box>
        }
        {item.id !== 'labels' && 
          item.unitLM !== '$' && 
          millify(Math.ceil(item.valueLM)) + ' '}
        <Text weight={'bold'} size={'medium'}>
          {item.unitLM}
        </Text>
        {item.unitLM === '$' && ' ' + millify(Math.ceil(item.valueLM))}
      </Text>

      {/* <Text size={'medium'} color={background} weight={'bold'}> */}
      {item.id !== 'labels' && <Box gap={'xsmall'} align={'center'}
      round={'none'}
      //background={background}
      background={'mesh-green-1'}
      width={'100%'}
      height={'45px'}
      flex={false}
      elevation={'small'}
      justify={'center'}
      >
        <Text 
          style={{ fontFamily: 'Montserrat, sans-serif'}}
          size={'20px'} 
          color={'white'} 
          weight={'normal'}
        >
          {item.name}
        </Text>
      </Box>
      }
      {item.id === 'labels' && <Box gap={'xsmall'} align={'center'} margin='15px 0'
      >
        <Text 
          style={{ fontFamily: 'Montserrat, sans-serif'}}
          size={'20px'} 
          color={'white'} 
          weight={'normal'}
        >
          {item.name}
        </Text>
      </Box>
      }
      <Text 
        style={{ fontFamily: 'Arvo, sans-serif', margin: '15px 0'}} 
        color={'mesh-green-1'} 
        size={'20px'} 
        weight={'bold'}
      >
        {item.id === 'labels' &&
        <Box align={'center'}>
        <Text 
          style={{ fontFamily: 'Arvo, sans-serif'}}
          size={'18px'} 
          color={'mesh-green-1'} 
          weight={'bold'}
        >
        Impact since
        </Text>
        <Text 
          style={{ fontFamily: 'Arvo, sans-serif'}}
          size={'18px'} 
          color={'mesh-green-1'} 
          weight={'bold'}
        >
        {item.start_date}
        </Text>
        </Box>
        }
        {item.id !== 'labels' && 
          item.unit !== '$' && 
          millify(Math.ceil(item.value)) + ' '}
        <Text weight={'bold'} size={'medium'}>
          {item.unit}
        </Text>
        {item.unit === '$' && ' ' + millify(Math.ceil(item.value))}
      </Text>
    </Box>
  </Box>
)
export const DonationMetricsSmallLM = ({
  metrics,
  loading,
  metricWidth = '40%',
  itemProps = {},
  ...rest
}) => {
  const { RenderComponent = MetricsBox, ...restOfItemProps } = itemProps
  return loading ? (
    <Box
      // background={loading ? 'light-4' : undefined}
      fill
      align={'center'}
      justify={'center'}
      height={rest.height}
    >
      <PropagateLoader
        loading={loading}
        size={16}
        color={meshTheme.global.colors['light-6']}
        width={'100%'}
      />
    </Box>
  ) : (
    <Grid
    style={{ marginRight: '17%'}}
      rows={'auto'}
      gap="small"
      //columns={metricWidth}
      // gap={{
      //   column: metrics.map((_, index) => (index < 2 ? 'tiny' : 'small')),
      // }}
      columns={['125px','auto', 'auto','auto']}
      align="center"
      justifyContent="center"
      justify="center"
      {...rest}
    >
      {!loading &&
        metrics.map((item, index) => (
          <RenderComponent
            key={item.id}
            width={'100%'}
            item={item}
            loading={loading}
            {...restOfItemProps}
          />
        ))}
      {rest.children}
    </Grid>
  )
}
export const DonationMetricsSmall = ({
  metrics,
  loading,
  metricWidth = '40%',
  itemProps = {},
  ...rest
}) => {
  const { RenderComponent = MetricsBox, ...restOfItemProps } = itemProps
  return loading ? (
    <Box
      // background={loading ? 'light-4' : undefined}
      fill
      align={'center'}
      justify={'center'}
      height={rest.height}
    >
      <PropagateLoader
        loading={loading}
        size={16}
        color={meshTheme.global.colors['light-6']}
        width={'100%'}
      />
    </Box>
  ) : (
    <Grid
      rows={'auto'}
      gap="small"
      columns={metricWidth}
      align="center"
      justifyContent="center"
      justify="center"
      {...rest}
    >
      {!loading &&
        metrics.map((item, index) => (
          <RenderComponent
            key={item.id}
            width={'100%'}
            item={item}
            loading={loading}
            {...restOfItemProps}
          />
        ))}
      {rest.children}
    </Grid>
  )
}
export const DonationMetrics = ({
  metrics,
  loading,
  elevation = 'small',
  metricWidth = { min: 'small', max: '100%' },
  ...rest
}) => (
  <Box
    direction={'row-responsive'}
    gap={'medium'}
    align="center"
    justify="center"
    fill={'horizontal'}
    {...rest}
  >
    {metrics.map((item, index) => (
      <Box
        background={'white'}
        // height="small"
        flex={'shrink'}
        align="center"
        justify={'center'}
        width={metricWidth}
        responsive={false}
        round={'small'}
        elevation={elevation}
        key={item.id}
        gap={'xsmall'}
        style={loading ? { opacity: '33%' } : undefined}
        pad={{ vertical: 'large', horizontal: 'medium' }}
      >
        <Box
          round={'small'}
          // pad={'small'}
          gap={'xsmall'}
          // background={{ color: 'mesh-green-3', opacity: '10%' }}
          // background={'mesh-gree'}
          align={'center'}
        >
          {item.Icon && <item.Icon color={'dark-6'} size={'60px'} />}

          <Text size={'2xl'} weight={'bold'}>
            {item.unit !== '$' && millify(Math.ceil(item.value)) + ' '}
            <Text weight={'bold'} size={'large'}>
              {item.unit}
            </Text>
            {item.unit === '$' && ' ' + millify(Math.ceil(item.value))}
          </Text>
          <Text size={'large'} color={'dark-6'} weight={'bold'}>
            {item.name}
          </Text>
        </Box>
      </Box>
    ))}
  </Box>
)
export class _DonationTable extends Component {
  static defaultProps = {
    fromApi: { results: [] },
    apiActions: {},
    show: false
  }
  state = { results: [] }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.fromApi.results !== this.props.fromApi.results) {
      console.log(
        'TABLE SUPDATING RESULTS',
        prevProps.fromApi.results === this.props.fromApi.results
      )
      this.prepArray(this.props.fromApi.results)
    }
  }
  componentDidMount() {
    console.log('MOUNTING...')
    this.prepArray(this.props.fromApi.results)
  }

  prepArray = (data) => {
    const results = data.map((item) => {
      const d = new Date(item.entry_time).toUTCString().split(' ')
      const ds = [...d].splice(0, 4).join(' ')
      return {
        ...item,
        date: ds,
        time: d[4],
        store_name: item.from_store.name,
        company_name: item.from_company.name,
        destination_name: destinations.find((i) => i.id === parseInt(item.destination)).name,
        department_name: departments.find((i) => i.id === parseInt(item.from_department)).name
      }
    })
    this.props.updateDonations && this.props.updateDonations(results)
    this.setState({ results: results })
  }
  render() {
    const {
      fromApi: { apiPath, apiLoading, resultCount },
      apiActions = {},
      apiFilterMenu,
      heading,
      dateInfo,
      show,
      step
    } = this.props
    const { results } = this.state
    const loading = apiLoading
    return (
      show && (
        <Box fill={'horizontal'} flex={false} gap={'small'} pad={{ bottom: 'large' }}>
          <Heading margin={{ vertical: 'xsmall' }}>{heading}</Heading>

          <Box
            round="small"
            pad={'medium'}
            background="white"
            elevation="small"
            // flex={'grow'}
            flex={false}
            fill={'horizontal'}
            gap={'small'}
          >
            {/*<LoadingHeader loading={loading} />*/}

            <DataTable
              fill={'horizontal'}
              paginate
              columns={[
                {
                  property: 'date',
                  header: 'Date'
                  // render: ({ date }) => <Text>{new Date(entry_time).toUTCString()}</Text>
                },
                {
                  property: 'time',
                  header: 'Time'
                  // render: ({ time }) => <Text>{new Date(entry_time).toTimeString()}</Text>
                },
                {
                  property: 'destination',
                  header: 'Destination',
                  // primary: true,
                  render: ({ destination }) => (
                    <Text>{destinations.find((i) => i.id === parseInt(destination)).name}</Text>
                  )
                },
                {
                  property: 'from_company',
                  header: 'Company',
                  // primary: true,
                  render: ({ from_company }) => <Text>{from_company.name}</Text>
                },
                {
                  property: 'from_store',
                  header: 'Store',
                  // primary: true,
                  render: ({ from_store }) => <Text>{from_store.name}</Text>
                },
                {
                  property: 'from_department',
                  header: 'Department',
                  render: ({ from_department }) => (
                    <Text>{departments.find((i) => i.id === parseInt(from_department)).name}</Text>
                  )
                },
                {
                  property: 'weight_kg',
                  header: 'Weight (kg)',
                  render: ({ weight_kg }) => <Text>{numberWithCommas(weight_kg)}</Text>
                }
                // {
                //   property: 'total_lbs',
                //   header: 'Total in LBS',
                //   render: ({ props: { weight = 'normal' }, total_lbs = '' }) => (
                //     <Text weight={weight}>{numberWithCommas(total_lbs)}</Text>
                //   )
                // },
              ]}
              data={results}
            />
            {dateInfo && (
              <Text
                textAlign="center"
                color={'dark-6'}
                size={'small'}
                margin={{ vertical: 'xsmall' }}
              >
                {dateInfo}
              </Text>
            )}
          </Box>
        </Box>
      )
    )
  }
}
export const DonationTable = withOpsApi(_DonationTable)

export class _DonationReport extends Component {
  static defaultProps = {
    fromApi: { results: [] },
    apiActions: {},
    show: false
  }
  state = {
    totals: [],
    metrics: [],
    destinationTotals: [],
    departmentTotals: [],
    loading: false,
    submitting: false
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.fromApi.results !== this.props.fromApi.results) {
      this.prepTotalsArray(this.props.fromApi.results)
    }
  }
  componentDidMount() {
    this.prepTotalsArray(this.props.fromApi.results)
  }
  otherRow = (destination, department, value, props = { weight: undefined }) => {
    return {
      destination: destination,
      department: department,
      total_kg: value && Math.ceil(value),
      total_lbs: '',
      percentage: '',
      props: props
    }
  }
  totalsRow = (
    destination,
    department,
    kg,
    totalKg,
    props = { weight: undefined },
    includeLbs = true
  ) => {
    return {
      destination: destination,
      department: department,
      total_kg: kg && Math.ceil(kg),
      total_lbs: kg && includeLbs ? Math.ceil(kg * 2.20462) : '',
      percentage: kg ? Math.ceil((kg / totalKg) * 100) : '',
      props: props
    }
  }
  prepTotalsArray = (data) => {
    const kgByDestination = {}
    const kgByDepartment = {}
    const destinationTotals = []
    const departmentTotals = []
    let kgAll = 0
    data.forEach((row) => {
      const destinationId = row.destination_id
      const departmentId = row.from_department_id
      if (kgByDestination[destinationId] === undefined) {
        kgByDestination[destinationId] = 0
      }
      if (kgByDepartment[departmentId] === undefined) {
        kgByDepartment[departmentId] = 0
      }
      kgByDestination[destinationId] += row.weight_kg__sum
      kgByDepartment[departmentId] += row.weight_kg__sum
      kgAll += row.weight_kg__sum
    })
    let totals = []
    Object.keys(kgByDepartment).forEach((id) => {
      const department = departments.find((i) => i.id === parseInt(id))
      // add the destination total
      departmentTotals.push({
        value: kgByDepartment[id],
        id: department ? department.name.toLowerCase() : '',
        label: department ? department.name : ''
      })
    })
    Object.keys(kgByDestination).forEach((id) => {
      const destination = destinations.find((i) => i.id === parseInt(id))
      // add the destination total
      destinationTotals.push({
        value: kgByDestination[id],
        id: destination ? destination.name.toLowerCase() : '',
        label: destination ? destination.name : ''
      })
      totals.push(
        this.totalsRow(
          destination ? destination.name : '',
          'Total',
          kgByDestination[id],
          kgByDestination[id],
          { weight: 'bold' }
        )
      )

      // add departments first
      data.forEach((row) => {
        if (row.destination_id === parseInt(id)) {
          const department = departments.find((i) => i.id === parseInt(row.from_department_id))

          totals.push(
            this.totalsRow(
              '',
              department ? department.name : '',
              row.weight_kg__sum,
              kgByDestination[id]
            )
          )
        }
      })
      totals.push(this.totalsRow(''))
    })
    totals.push(this.totalsRow(''))
    totals.push(this.totalsRow(''))
    totals.push(this.totalsRow('All', 'Total', kgAll, kgAll, { weight: 'bold' }))
    totals.push(this.totalsRow(''))

    const apiValues = getTotalByKeyFromResults(data, [
      'meals_provided__sum',
      'money_saved__sum',
      'food_rescued_kg__sum',
      'co2_emissions_kg__sum'
    ])
    const metrics = calculateImpactMetrics(
      0,
      0,
      {
        showMoneySaved: false
      },
      apiValues
    )
    this.props.updateTotals && this.props.updateTotals({ totals: totals, metrics: metrics })
    this.setState({
      totals: totals,
      metrics: metrics,
      destinationTotals: destinationTotals,
      departmentTotals: departmentTotals,
      kgByDepartment: kgByDepartment,
      kgByDestination: kgByDestination
    })
  }
  render() {
    const { submitting, metrics, destinationTotals, departmentTotals } = this.state
    const {
      fromApi: { apiPath, apiLoading, resultCount, results = [] },
      apiActions = {},
      apiFilterMenu,
      heading,
      dateInfo,
      show
    } = this.props
    const loading = apiLoading
    return (
      show && (
        <Box fill={'horizontal'} flex={false} gap={'small'} pad={{ bottom: 'large' }}>
          <Heading margin={{ vertical: 'xsmall' }}>{heading}</Heading>

          <Box flex="grow" justify={'center'} direction={'row-responsive'}>
            <Box width={'100%'} height={'medium'}>
              <DonationsPie data={destinationTotals} />
            </Box>
            <Box width={'100%'} height={'medium'}>
              <DonationsPie data={departmentTotals} />
            </Box>
          </Box>
          <Box gap="medium" direction={'row-responsive'}>
            <Box width={'small'} gap={'small'}>
              <Box round={'small'} pad={'small'}>
                <Heading level={4} margin={'none'}>
                  Impact Metrics
                </Heading>
              </Box>
              <DonationMetrics width={'small'} direction="column" metrics={metrics} />
              <Box round={'small'} pad={'small'}>
                <Anchor
                  size={'small'}
                  label={'Our stats explained'}
                  reverse
                  weight={'normal'}
                  color={'dark-6'}
                  icon={<CircleInformation size={'small'} />}
                  href={'https://foodmesh.ca/our-stats-explained/'}
                  target={'_blank'}
                />
              </Box>
            </Box>
            <Box
              round="small"
              pad={'medium'}
              background="white"
              elevation="small"
              flex={'grow'}
              gap={'small'}
            >
              <DataTable
                fill={'horizontal'}
                pin
                columns={[
                  {
                    property: 'destination',
                    header: '',
                    primary: true
                  },
                  {
                    property: 'department',
                    header: '',
                    render: ({ department = '' }) => (
                      <Text weight={department.toLowerCase() === 'total' ? 'bold' : 'normal'}>
                        {department}
                      </Text>
                    )
                  },
                  {
                    property: 'total_kg',
                    header: 'Total in KG',
                    render: ({ props: { weight = 'normal' }, total_kg = '', row }) => (
                      <Text weight={weight}>{numberWithCommas(total_kg)}</Text>
                    )
                  },
                  {
                    property: 'total_lbs',
                    header: 'Total in LBS',
                    render: ({ props: { weight = 'normal' }, total_lbs = '' }) => (
                      <Text weight={weight}>{numberWithCommas(total_lbs)}</Text>
                    )
                  },
                  {
                    property: 'percentage',
                    header: '%',
                    render: ({ props: { weight = 'normal' }, percentage = '' }) => (
                      <Text weight={weight}>{percentage}</Text>
                    )
                  }
                ]}
                data={this.state.totals}
              />
              {dateInfo && (
                <Text
                  textAlign="center"
                  color={'dark-6'}
                  size={'small'}
                  margin={{ vertical: 'xsmall' }}
                >
                  {dateInfo}
                </Text>
              )}
            </Box>
          </Box>
        </Box>
      )
    )
  }
}

export const DonationReport = withOpsApi(_DonationReport)

export class DonationReportPage extends Component {
  /**
   * This loads donation data for month and year using child components and allows excel sheet download
   * */
  monthlyTotals = { totals: [], metrics: {} }
  yearlyTotals = { totals: [], metrics: {} }
  monthlyDonations = []
  currentDate = new Date()

  state = {
    activeTabIndex: 0,
    yearStartDate: null,
    monthStartDate: null,
    monthEndDate: null,
    monthStartDateISO: '',
    monthEndDateISO: '',
    yearStartDateISO: '',
    heading: '',
    reportMonthLoading: false,
    reportYearLoading: false,
    reportDataLoading: false,
    nameLoading: false,
    loadingChildren: false
  }
  // shouldComponentUpdate(nextProps, nextState, nextContext) {
  //   console.log(nextState, nextContext)
  //   if (nextState.monthStartDateISO === this.state.monthStartDateISO) {
  //     return false
  //   }
  //   return true
  // }
  setReportLoading = (data) => {
    const { reportMonthLoading, reportYearLoading, reportDataLoading, nameLoading } = data
    if (reportMonthLoading !== undefined) {
      this.setState({ reportMonthLoading: reportMonthLoading }, this.areChildrenLoading)
    }
    if (reportYearLoading !== undefined) {
      this.setState({ reportYearLoading: reportYearLoading }, this.areChildrenLoading)
    }
    if (reportDataLoading !== undefined) {
      this.setState({ reportDataLoading: reportDataLoading }, this.areChildrenLoading)
    }
    if (nameLoading !== undefined) {
      this.setState({ nameLoading: nameLoading }, this.areChildrenLoading)
    }
  }
  areChildrenLoading = () => {
    const { reportMonthLoading, reportYearLoading, reportDataLoading, nameLoading } = this.state
    let childStates = [reportMonthLoading, reportYearLoading, nameLoading]
    // only loading donation data for receivers
    this.props.apiParams.receiver_id && childStates.push(reportDataLoading)

    const loading = !childStates.every((s) => s === false)
    this.setState({ loadingChildren: loading })
  }
  onActiveTab = (nextIndex) => this.setState({ activeTabIndex: nextIndex })
  addTitleTable = (worksheet, subTitle) => {
    // add a temp table below
    worksheet.insertRow(0)
    worksheet.insertRow(0)
    worksheet.insertRow(0)
    worksheet.getCell('A1').value = this.state.heading
    worksheet.getCell('A2').value = subTitle

    worksheet.mergeCells('A1:D1')
    worksheet.mergeCells('A2:D2')
    worksheet.getRow(1).font = {
      bold: true,
      size: 18,
      color: { argb: brandColors['mesh-purple-1'].replace('#', 'FF') }
    }
    worksheet.getRow(2).font = {
      bold: true,
      size: 12,
      color: { argb: brandColors['mesh-accent-dark'].replace('#', 'FF') }
    }
  }
  addMetricsTable = (data, worksheet) => {
    // add a temp table below
    worksheet.addTable({
      name: 'Metrics',
      ref: 'A' + String(data.totals.length + 5),
      headerRow: true,
      totalsRow: false,
      style: {
        theme: 'TableStyleLight1',
        showRowStripes: false
      },
      // id: 'meals',
      // name: 'Meals Created',
      // value: kgByDestination[1] / 0.6,
      // unit: 'meals',
      // color: 'dark-1'
      columns: [{ name: 'Stats' }, { name: ' ' }, { name: ' ' }],
      rows: data.metrics.map((row) => [row.name, Math.ceil(row.value) + ' ' + row.unit])
    })
  }
  addToWorkSheet = (data, worksheet) => {
    console.log(data, worksheet)
    // loop through data and add each one to worksheet
    data.forEach((singleData, index) => {
      worksheet.addRow(singleData)
      if (singleData.props && singleData.props.weight === 'bold') {
        // console.log(singleData)
        const row = worksheet.getRow(index + 2)
        row.font = {
          bold: true,
          color: { argb: brandColors['mesh-green-2'].replace('#', 'FF') }
        }
        // store each cell to currentCell
        const currentCell = row._cells

        // loop through currentCell to apply border only for the non-empty cell of excel
        currentCell.forEach((singleCell) => {
          // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
          const cellAddress = singleCell._address

          // apply border
          worksheet.getCell(cellAddress).border = {
            top: { style: 'thick' },
            // left: { style: 'thin' },
            bottom: { style: 'thin' }
            // right: { style: 'thin' }
          }
        })
      }
    })
  }
  exportFile = async () => {
    this.setState({ submitting: true })

    const workbook = new Excel.Workbook()

    const columns = [
      { header: 'Destination', key: 'destination' },
      { header: 'Department', key: 'department' },
      { header: 'Total in KG', key: 'total_kg' },
      { header: 'Total in LBS', key: 'total_lbs' }
    ]
    const columnDonations = [
      { header: 'Date       ', key: 'date' },
      { header: 'Time', key: 'time' },
      { header: 'Company        ', key: 'company_name' },
      { header: 'Store          ', key: 'store_name' },
      { header: 'Destination', key: 'destination_name' },
      { header: 'Department   ', key: 'department_name' },
      { header: 'Weight (kg)', key: 'weight_kg' }
    ]
    const clsIndex = [columns, columns, columnDonations]
    const fileName =
      this.state.heading.split(' ').join('-') + '_' + this.state.monthEndDateISO.split('T')[0]

    // creating one worksheet in workbook
    const worksheetM = workbook.addWorksheet('Month', {
      // headerFooter: { firstHeader: 'Monthly Report', firstFooter: 'sad' }
    })
    const worksheetYTD = workbook.addWorksheet('YTD')
    const worksheetDonations = workbook.addWorksheet('Raw Data')
    const worksheets = [worksheetM, worksheetYTD, worksheetDonations]

    worksheets.forEach((worksheet, index) => {
      // add worksheet columns
      // add worksheet columns
      // each columns contains header and its mapping key from data
      worksheet.columns = clsIndex[index]

      // updated the font for first row.

      // loop through all of the columns and set the alignment with width.
      worksheet.columns.forEach((column, index) => {
        column.width = column.header.length + 5
        column.alignment = { horizontal: index === 0 ? 'left' : 'right' }
      })

      worksheet.getRow(1).font = { bold: true }
    })

    // this.addTitleTable('test', [['Report', 'Monthly']], worksheetM)

    this.addToWorkSheet(this.monthlyTotals.totals, worksheetM)
    this.addTitleTable(worksheetM, 'Month range: ' + this.getMonthRangeAsString())

    this.addToWorkSheet(this.yearlyTotals.totals, worksheetYTD)
    this.addTitleTable(worksheetYTD, 'YTD: ' + this.getYearStartRangeAsString())

    this.addToWorkSheet(this.monthlyDonations, worksheetDonations)
    this.addTitleTable(worksheetDonations, 'Month range: ' + this.getMonthRangeAsString())

    this.addMetricsTable(this.monthlyTotals, worksheetM)
    this.addMetricsTable(this.yearlyTotals, worksheetYTD)
    // // loop through all of the rows and set the outline style.
    // worksheet.eachRow({ includeEmpty: false }, (row) => {
    //   // store each cell to currentCell
    //   const currentCell = row._cells
    //
    //   // loop through currentCell to apply border only for the non-empty cell of excel
    //   currentCell.forEach((singleCell) => {
    //     // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
    //     const cellAddress = singleCell._address
    //
    //     // apply border
    //     worksheet.getCell(cellAddress).border = {
    //       top: { style: 'thin' },
    //       left: { style: 'thin' },
    //       bottom: { style: 'thin' },
    //       right: { style: 'thin' }
    //     }
    //   })
    // })

    // write the content using writeBuffer
    const buf = await workbook.xlsx.writeBuffer()

    // download the processed file
    saveAs(new Blob([buf]), `${fileName}.xlsx`)
    this.setState({ submitting: false })
  }
  componentDidMount() {
    const date = new Date()
    date.setMonth(date.getMonth() - 1)
    this.setDateRange(date)
    let { apiParams } = this.props
    const { _options = {} } = apiParams
    let url = ''
    if (apiParams.receiver_id) {
      url = 'reports/receivers/' + apiParams.receiver_id
    }
    if (apiParams.from_store_id) {
      url = 'reports/stores/' + apiParams.from_store_id
    }
    const response = opsAPI.getFromRetail(url, {}, _options)
    response.then((result) => {
      this.setState({ heading: result.data.name })
    })
  }

  updateMonthly = (value) => {
    this.monthlyTotals = value
  }
  updateYearly = (value) => {
    this.yearlyTotals = value
  }
  updateDonations = (value) => {
    this.monthlyDonations = value
  }
  getMonthYearAsString = () => {
    return (
      monthNames[this.state.monthEndDate.getMonth()] + ' ' + this.state.monthEndDate.getFullYear()
    )
  }
  getMonthRangeAsString = () => {
    return (
      this.state.monthStartDate.toLocaleString() + ' - ' + this.state.monthEndDate.toLocaleString()
    )
  }
  getYearStartRangeAsString = () => {
    return (
      this.state.yearStartDate.toLocaleString() + ' - ' + this.state.monthEndDate.toLocaleString()
    )
  }
  setDateRange = (date = null, month = undefined) => {
    const currentDate = date ? new Date(date) : new Date()
    const offsetTimeZoneHours = currentDate.getTimezoneOffset() / 60
    const currentYear = currentDate.getFullYear()
    const currentMonth = month === undefined ? currentDate.getMonth() : month
    const monthStartDate = new Date(currentYear, currentMonth, 1, -offsetTimeZoneHours, -1, 59)
    const yearStartDate = new Date(currentYear, 0, 1, -offsetTimeZoneHours, 59, 59)
    const monthEndDate = new Date(
      currentYear,
      currentMonth + 1,
      0,
      23 - offsetTimeZoneHours,
      59,
      59,
      59
    )

    this.setState(
      {
        yearStartDateISO: yearStartDate.toISOString(),
        monthStartDateISO: monthStartDate.toISOString(),
        monthEndDateISO: monthEndDate.toISOString(),
        offsetTimeZoneHours: offsetTimeZoneHours
      },
      () => {
        yearStartDate.setHours(0)
        monthStartDate.setHours(0)
        monthEndDate.setHours(0)
        this.setState({
          yearStartDate: new Date(yearStartDate),
          monthStartDate: new Date(monthStartDate),
          monthEndDate: new Date(monthEndDate)
        })
      }
    )
  }
  render() {
    const { apiParams = {}, ...rest } = this.props
    const {
      yearStartDate,
      monthStartDate,
      monthEndDate,
      monthStartDateISO,
      monthEndDateISO,
      yearStartDateISO,
      heading,
      activeTabIndex,
      loadingChildren
    } = this.state
    return (
      yearStartDate && (
        <Box fill background={'light-3'}>
          <Main
            flex={'shrink'}
            // pad={{ horizontal: 'none', top: 'bo', bottom: 'large' }}
          >
            <LoadingHeader background="light-1" loading={loadingChildren} />

            <PageHeader pad="medium" direction={'row-responsive'} heading={heading}>
              <Box flex={'grow'} />
              <SelectMonthInYear
                disabled={loadingChildren}
                endDate={this.currentDate}
                selectAction={({ year, month }) => this.setDateRange(new Date(year, month, 15))}
              />
              <Button
                disabled={loadingChildren}
                primary
                label="Download"
                icon={<CloudDownload />}
                onClick={this.exportFile}
              />
            </PageHeader>
            <Box
              fill={'horizontal'}
              flex={false}
              align="center"
              justify="center"
              gap="medium"
              pad={'large'}
              direction={'row-responsive'}
            >
              <Button
                primary
                disabled={loadingChildren}
                color={'light-6'}
                active={activeTabIndex === 0}
                label={'Month'}
                onClick={() => this.onActiveTab(0)}
              />
              <Button
                disabled={loadingChildren}
                primary
                color={'light-6'}
                active={activeTabIndex === 1}
                label={'YTD'}
                onClick={() => this.onActiveTab(1)}
              />
              {apiParams.receiver_id && (
                <Button
                  primary
                  disabled={loadingChildren}
                  color={'light-6'}
                  active={activeTabIndex === 2}
                  label={'Raw Data'}
                  onClick={() => this.onActiveTab(2)}
                />
              )}
            </Box>
            <Box align="center" fill="horizontal" pad={{ horizontal: 'large' }} gap={'large'}>
              <Stack interactiveChild={activeTabIndex} fill>
                <DonationReport
                  show={activeTabIndex === 0}
                  key={'monthly'}
                  apiPath={'retail/reports/donation_totals'}
                  apiGroupBy={['destination_id', 'from_department_id']}
                  apiParams={{
                    ...apiParams,
                    ...{
                      annotate_metrics: true,
                      entry_time__gt: monthStartDateISO,
                      entry_time__lte: monthEndDateISO
                    }
                  }}
                  dateInfo={'Reporting ' + this.getMonthRangeAsString()}
                  heading={'Monthly Donations for ' + this.getMonthYearAsString()}
                  {...rest}
                  loaderProps={{ loader: 'propagate' }}
                  updateTotals={this.updateMonthly}
                  loadingStateAction={(value) =>
                    this.setReportLoading({ reportMonthLoading: value })
                  }
                />
                <DonationReport
                  show={activeTabIndex === 1}
                  key={'yearly'}
                  apiPath={'retail/reports/donation_totals'}
                  dateInfo={
                    'Reporting ' +
                    yearStartDate.toLocaleString() +
                    ' - ' +
                    monthEndDate.toLocaleString()
                  }
                  apiParams={{
                    ...apiParams,
                    ...{
                      annotate_metrics: true,
                      entry_time__gt: yearStartDateISO,
                      entry_time__lte: monthEndDateISO
                    }
                  }}
                  heading={'YTD ending ' + this.getMonthYearAsString()}
                  {...rest}
                  loaderProps={{ loader: 'propagate' }}
                  updateTotals={this.updateYearly}
                  loadingStateAction={(value) =>
                    this.setReportLoading({ reportYearLoading: value })
                  }
                />
                {apiParams.receiver_id && (
                  <DonationTable
                    show={activeTabIndex === 2}
                    key={'monthly-table'}
                    apiPath={'retail/reports/donations'}
                    apiParams={{
                      ...apiParams,
                      ...{
                        expand: ['from_store', 'from_company'],
                        // limit: 1000,
                        limit:40000,
                        entry_time__gt: monthStartDateISO,
                        entry_time__lte: monthEndDateISO
                      }
                    }}
                    dateInfo={'Reporting ' + this.getMonthRangeAsString()}
                    heading={'Monthly data for ' + this.getMonthYearAsString()}
                    {...rest}
                    loaderProps={{ loader: 'propagate' }}
                    updateDonations={this.updateDonations}
                    loadingStateAction={(value) =>
                      this.setReportLoading({ reportDataLoading: value })
                    }
                  />
                )}
              </Stack>

              <Box pad={'large'} />
            </Box>
          </Main>
        </Box>
      )
    )
  }
}
